module.exports = (__webpack_require__(0))(32);


//////////////////
// WEBPACK FOOTER
// delegated ./clients/web/src/utilities/EventStream.js from dll-reference girder_lib
// module id = 43
// module chunks = 0